// ============================================================================
// KAN-22：Paris endoscopic classification（巴黎內視鏡分類）提示字卡的內容結構。
//
// 醫師操作 morphology 欄位時常忘記各分類定義，於欄位旁提供可開啟的提示字卡
// （比照既有 finding hint 互動）。此檔只定義「顯示順序 + 階層」，實際文字（型別名稱
// 與白話定義）走 i18n（`paris_hint.*`，繁中 / 英 / 日），符合多語系規約。
//
// level 0＝主型別（粗體群組標題）、level 1＝子分類（縮排項目）。
// ⚠️ 若工單 PPT 版本與此有出入，George 會事後校正——調整只需改 i18n 文字，結構不動。
// ============================================================================

export const ParisClassification = [
  { key: "type_0_i", level: 0 }, // 0-I 隆起型
  { key: "type_0_ip", level: 1 }, // 0-Ip 有蒂
  { key: "type_0_is", level: 1 }, // 0-Is 無蒂
  { key: "type_0_ii", level: 0 }, // 0-II 表淺型
  { key: "type_0_iia", level: 1 }, // 0-IIa 微隆起
  { key: "type_0_iib", level: 1 }, // 0-IIb 平坦
  { key: "type_0_iic", level: 1 }, // 0-IIc 微凹陷
  { key: "type_0_iii", level: 0 }, // 0-III 凹陷型
];
